module.exports = __webpack_public_path__ + "static/img/2.8a20b4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/2.png
// module id = +Oy7
// module chunks = 1